<p>vacation-widget-base works!</p>
